'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002452 from "./presto.types$-Credential-Username$$anon$52.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002453 from "./presto.types$-Credential-Username$$anon$53.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialUsername$() {
  this.c4k = null;
  this.c4l = false;
  this.c4o = null;
  this.c4p = false;
  this.c4m = null;
  this.c4n = false;
  this.c4q = null;
  this.c4r = false;
}
export { $c_Lpresto_types$CredentialUsername$ as $c_Lpresto_types$CredentialUsername$ };
$p = $c_Lpresto_types$CredentialUsername$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialUsername$;
/** @constructor */
function $h_Lpresto_types$CredentialUsername$() {
}
export { $h_Lpresto_types$CredentialUsername$ as $h_Lpresto_types$CredentialUsername$ };
$h_Lpresto_types$CredentialUsername$.prototype = $p;
$p.gH = (function() {
  if ((!this.c4l)) {
    this.c4k = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c4l = true;
  }
  return this.c4k;
});
$p.crM = (function() {
  if ((!this.c4p)) {
    this.c4o = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c4p = true;
  }
  return this.c4o;
});
$p.cHT = (function() {
  if ((!this.c4n)) {
    this.c4m = new $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002452.$c_Lpresto_types$CredentialUsername$$anon$52(this);
    this.c4n = true;
  }
  return this.c4m;
});
$p.a2z = (function() {
  if ((!this.c4r)) {
    this.c4q = new $j_presto$002etypes$0024$002dCredential$002dUsername$0024$0024anon$002453.$c_Lpresto_types$CredentialUsername$$anon$53(this);
    this.c4r = true;
  }
  return this.c4q;
});
var $d_Lpresto_types$CredentialUsername$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialUsername$, "presto.types$CredentialUsername$", ({
  Zs: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialUsername$ as $d_Lpresto_types$CredentialUsername$ };
var $n_Lpresto_types$CredentialUsername$;
function $m_Lpresto_types$CredentialUsername$() {
  if ((!$n_Lpresto_types$CredentialUsername$)) {
    $n_Lpresto_types$CredentialUsername$ = new $c_Lpresto_types$CredentialUsername$();
  }
  return $n_Lpresto_types$CredentialUsername$;
}
export { $m_Lpresto_types$CredentialUsername$ as $m_Lpresto_types$CredentialUsername$ };
//# sourceMappingURL=presto.types$-Credential-Username$.js.map
